<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">
        {{ form.ctype != 0 ? "合同会签审批表" : "合同备案审批表" }}
      </h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <el-form
            ref="form"
            v-if="form.ctype != 0"
            label-width="140px"
            class="form"
            style="margin-bottom: -25px"
          >
            <el-form-item label="需求类型">
              <el-radio-group v-model="contractType" class="type-radio-type">
                <el-radio-button label="1">集团审批</el-radio-button>
                <el-radio-button label="2">子公司内部审批</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>

          <create-contract-approval
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          >
          </create-contract-approval>

          <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :arr="attachmentArr"
                :type="11"
              ></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item
              ref="approval"
              :approvalUsers="approvalUsersData"
              :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"
            ></approval-item>
          </div>

          <div v-if="form.ctype != 0" class="tip tip-table">
            <!-- 合同会签 -->
            <p>
              <span class="tip-lable">注：</span
              >1.属“三重一大”事项的需附“三重一大”事项会议记录表；
            </p>
            <p>
              2.合同承办部门将送审合同文本草案向每一审核会签部门提交，审核部门应在1个完整工作日内审核完毕。审核部门如遇特殊情况需要延长审核时间的，应向承办人员说明理由；
            </p>
            <p>
              3.合同若为供水及污水处理服务合同，则需在是否大客户一栏中进行填写；
            </p>
            <p>4.“相关业务部门审核”一栏适用于子公司合同递交集团公司会签；</p>
            <p>
              5.“账务管理部审核”和“财务总监审核”只选其一，财务总监监管范围内的合同由财务总监审核，监管范围外的由财务管理部审核。
            </p>
          </div>
          <div v-else class="tip tip-table">
            <!-- 合同备案 -->
            <!-- 2021-02-26要求删除 --
            <p>
              1、工程合同备案到战略企划部；采购合同（工程服务采购除外）备案到资产运营部；其他合同备案到内控法务部；
            </p> -->
            <p>
              <span class="tip-lable">注：</span
              >1、5万元以上采购合同、8万元以上（金额根据监管范围调整）工程的施工合同及建设相关合同需财务总监审核（根据会签的招标文件签订的除外）
            </p>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createProject()"
                class="form-btn"
                type="success"
              >
                {{
                  form.ctype != 0
                    ? "确认提交合同会签审批表"
                    : "确认提交合同备案审批表"
                }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>

    <!-- form.ctype -->
    <!-- 保存草稿 -->
    <auto-save
      :form="form"
      :saveName="'ContractApproval' + form.ctype"
      @getForm="getFormData"
      @updateForm="updateForm"
    >
    </auto-save>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "@/components/ApprovalItem";
import CreateContractApproval from "@/page/form/createContractApproval";

import AutoSave from "@/components/AutoSave";
import saveForm from "@/Mixins/saveForm";

import ObjectUtil from "../mixins/objectUtil";
export default {
  props: ["ctype"],
  components: {
    ApprovalItem,
    CreateContractApproval,
    Attachments,
    AutoSave,
  },
  mixins: [approvalUsers, saveForm, ObjectUtil],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      contractType: 1,

      project: {},
      form: {
        ctype: 1,
        isYhyb: "0",
        projectId: "",
        name: "",
        number: "",
        type: 0,
        customer: "",
        price: "",
        isBigCustomer: "0",
        isBigContract: "0",
        outline: "",
        content: "",
        remark: "",
        cbdw: "",
        cbr: "",
        cbdwfzr: "",

        // 是否8万以下工程，5万以下设计监理
        isLowcost: false,

        // 是否线下审批通过
        underLine: "",
      },
      hasApplyId: "",
      approvalUsersData: [],

      // 附件
      attachmentArr: [],
      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
    };
  },
  created() {
    console.log(this.ctype);
    if (this.ctype != undefined) {
      this.form.ctype = this.ctype;
    }
    // if(this.$route.params.ctype){
    //   this.form.ctype = this.$route.params.ctype
    // }

    this.getApplyData();
  },
  mounted() {
    this.form.projectId = this.$route.params.projectId;
    this.getProject();
    this.approvalUsersData = this.approvalUsers["c11_" + this.form.ctype];

    console.log(this.form.ctype);
    console.log(this.approvalUsersData);
  },
  methods: {
    // 获取审批表原内容
    getApplyData() {
      this.hasApplyId = this.$route.params.applyId ? true : false;
      this.form.signId = this.$route.params.applyId;
      if (this.form.signId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        this.setSelectArr(this.applyInfo, 11, this.form.ctype / 1);
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get(
        "/gc/project/contractsign/info/" + this.form.signId,
        "",
        (res) => {
          this.applyInfo = res.vo;

          this.form.ctype = this.applyInfo.ctype;
          this.form.isYhyb = this.applyInfo.isYhyb
            ? this.applyInfo.isYhyb.toString()
            : "0";

          this.form.name = this.applyInfo.name;
          this.form.number = this.applyInfo.number;
          this.form.type = this.applyInfo.type / 1;
          this.form.customer = this.applyInfo.customer;

          this.form.price = this.applyInfo.price;
          this.form.isBigCustomer = this.applyInfo.isBigCustomer.toString();
          this.form.isBigContract = this.applyInfo.isBigContract.toString();
          this.form.outline = this.applyInfo.outline;
          this.form.content = this.applyInfo.content;

          this.form.remark = this.applyInfo.remark;
          this.form.cbdw = this.applyInfo.cbdw;
          this.form.cbr = this.applyInfo.cbr;
          this.form.cbdwfzr = this.applyInfo.cbdwfzr;

          this.form.isLowcost = this.applyInfo.isLowcost == 1 ? true : false;

          // 是否线下通过审批
          this.form.underLine = this.applyInfo.underLine.toString();

          this.attachmentArr = this.applyInfo.attachments
            ? this.applyInfo.attachments
            : [];

          this.setSelectArr(this.applyInfo, 11, this.form.ctype / 1);
          this.formLoading = false;
        }
      );
    },
    // 获取所有项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);
      });
    },
    // 提交项目申请
    createProject() {
      this.form = this.$refs.create.getFromData();
      if (this.form.underLine == "") {
        this.$message.error("请标注本次审批是否已线下通过");
        return;
      }

      // 赋值合同ID
      this.form.contractId = this.project.contractId;

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      this.form.attachments = this.$refs.attachments.getAttachments();

      if (this.form.isLowcost && this.form.ctype == 0) {
        this.form.approvalUserIds = this.form.approvalUserIds
          .split(",")
          .slice(0, 3)
          .join(",");
      }
      this.form.isLowcost = this.form.isLowcost ? "1" : "0";

      this.formLoading = true;
      let _url = !this.form.signId
        ? "/gc/project/contractsign"
        : "/gc/project/contractsign/edit";

      console.log(this.form.approvalUserIds);
      // return
      // this.formLoading = false
      ajax.post(
        _url,
        this.form,
        (res) => {
          if (this.form.ctype) {
            this.$message.success("提交合同会签审批表成功，请耐心等待领导审批");
          } else {
            this.$message.success("提交合同备案审批表成功，请耐心等待领导审批");
          }

          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {
    contractType() {
      if (this.contractType == 2) {
        if (this.userData.deptDetail) {
          // 原水
          this.form.ctype = 3;
        } else {
          this.form.ctype = 2;
        }
      } else {
        this.form.ctype = this.contractType;
      }
    },
    "form.ctype"() {
      this.approvalUsersData = this.approvalUsers["c11_" + this.form.ctype];
      if (this.form.ctype != 0) {
        if (this.form.ctype == this.applyInfo.ctype) {
          this.setSelectArr(this.applyInfo, 11, this.form.ctype / 1);
        } else {
          this.setSelectArr("", 11, this.form.ctype / 1);
        }
        switch (this.form.ctype) {
          case "1":
            this.contractType = 1;
            break;
          case "2":
          case "3":
            this.contractType = 2;
            break;
        }
      }
    },
    "form.isLowcost"() {
      if (this.form.isLowcost && this.form.ctype == 0) {
        let _approvalUsersData = this.approvalUsers[
          "c11_" + this.form.ctype
        ].slice(0, 2);
        _approvalUsersData[1].users = _approvalUsersData[1].users.slice(0, 1);
        this.approvalUsersData = _approvalUsersData;
      } else if (this.form.ctype == 0) {
        (this.approvalUsers["c11_" + this.form.ctype] = [
          {
            name: "需求单位审批",
            users: ["分管副总", "总经理"],
          },
          {
            name: "审核主体",
            users: ["相关部门(资产运营部/战略企划部)", "财务总监"],
          },
        ]),
          (this.approvalUsersData = this.approvalUsers[
            "c11_" + this.form.ctype
          ]);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createContractApproval.vue